export default ({setStage}) => {
    return (
            <div className="action-modal-body-container">
                <div className="modal-body stage-body app-guide-body">
                    <div className="stage-header">
                        <div className="left">
                            <div className="title">IOS Tutorial</div>
                            <div className="text">Follow these quick steps to add the app and claim your bonus.</div>
                        </div>
                        <div className="close" onClick={e => setStage(null)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <div className="app-guide">
                        <div className="step">
                            <div className="title">Step 1</div>
                            <div className="description">Tap the Share button at the bottom of your screen.</div>
                            <img src={`${window.location.origin}/source/system/app-guide/ios/ios-1.png`} alt="Step 1" />
                        </div>

                        <div className="step">
                            <div className="title">Step 2</div>
                            <div className="description">Scroll down and tap “Add to Home Screen”.</div>
                            <img src={`${window.location.origin}/source/system/app-guide/ios/ios-2.png`} alt="Step 2" />
                        </div>

                        <div className="step">
                            <div className="title">Step 3</div>
                            <div className="description">Tap “Add” in the top-right corner to confirm.</div>
                            <img src={`${window.location.origin}/source/system/app-guide/ios/ios-3.png`} alt="Step 2" />
                        </div>
                    </div>

                    <div className="buttons">
                        <div className="row">
                            <div className="button" onClick={e => setStage(null)}>
                                Okay, got it
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}